import { useState } from 'react'
import { message } from 'core/components/ui'
import RequesterConfigurator, {
  requesterConfiguratorMethods
} from 'core/requesters/RequesterConfigurator'

const useGetConfigurator = props => {
  const { redirectMessage } = props
  const [loading, setLoading] = useState(false)
  const [makes, setMakes] = useState(null)
  const [groupsModel, setGroupsModel] = useState(null)
  const [models, setModels] = useState(null)
  const [trims, setTrims] = useState(null)
  const [carOptions, setCarOptions] = useState(null)
  const [versions, setVersions] = useState(null)
  const [designs, setDesigns] = useState(null)
  const [contracts, setContracts] = useState(null)

  const getMakes = () => {
    setLoading(true)

    RequesterConfigurator.get(requesterConfiguratorMethods.GET_BRANDS, null, redirectMessage)
      .then(datas => {
        const list = datas.makes.map(make => {
          const brand = {
            id: make.id,
            name: make.make
          }

          return brand
        })

        setMakes(list)
      })
      .catch(e => message.error(e))
      .finally(() => {
        setLoading(false)
      })
  }

  const getGroupsModel = params => {
    setLoading(true)

    RequesterConfigurator.get(
      requesterConfiguratorMethods.GET_GROUP_MODELS,
      params,
      redirectMessage
    )
      .then(datas => {
        const { groupModels } = datas

        const list = groupModels.map(item => {
          const groupModel = {
            name: item.groupModel,
            id: item.groupModelId,
            urlImage: item.picture
            //  price: Number(item.f_veh_prhnp1_min),
            // funding: null
          }
          return groupModel
        })

        setGroupsModel(list)
      })
      .catch(e => message.error(e))
      .finally(() => {
        setLoading(false)
      })
  }

  const getModels = params => {
    setLoading(true)
    RequesterConfigurator.get(requesterConfiguratorMethods.GET_MODELS, params, redirectMessage)
      .then(datas => {
        const list = datas.models.map(item => {
          const exportItem = {
            name: item.model,
            id: item.id,
            urlImage: item.picture,
            price: Number(item.inclVatPrice)
            //funding: null
          }

          return exportItem
        })

        setModels(list)
      })
      .catch(e => message.error(e))
      .finally(() => {
        setLoading(false)
      })
  }

  const getTrims = params => {
    setLoading(true)
    RequesterConfigurator.get(requesterConfiguratorMethods.GET_FINISHES, params, redirectMessage)
      .then(datas => {
        const list = datas.trims.map(trim => ({
          id: trim.id,
          title: trim.trim,
          price: trim.inclVatPrice,
          catalog: trim.beginPrice,
          items: trim.equipments.map(equipment => ({
            title: equipment
          })),
          equipements: trim.equipments.map(equipment => ({
            title: equipment
          }))
        }))

        setTrims(list)
      })
      .catch(e => message.error(e))
      .finally(() => {
        setLoading(false)
      })
  }

  const getOptions = params => {
    setLoading(true)
    RequesterConfigurator.get(requesterConfiguratorMethods.GET_EQUIPMENTS, params, redirectMessage)
      .then(datas => {
        /*const list = datas.equipments.map(item => ({
          title: item.equipment,
          id: item.id
        }))*/

        setCarOptions(datas)
      })
      .catch(e => {
        message.error(e)
      })
      .finally(() => {
        setLoading(false)
      })
  }

  const getVersions = params => {
    setLoading(true)

    RequesterConfigurator.get(requesterConfiguratorMethods.GET_VERSIONS, params, redirectMessage)
      .then(datas => {
        const list = datas.versions.map(version => ({
          id: version.id,
          title: version.version,
          price: version.inclVatPrice,
          energy: version.fuel,
          gearBox: version.transmissionType,
          power: version.horsepower,
          consumption: version.mixedConsumption,
          doors: version.doors,
          co2: version.co2Emission,
          catalog: version.beginPrice
        }))

        setVersions(list)
      })
      .catch(e => message.error(e))
      .finally(() => {
        setLoading(false)
      })
  }

  const getDesign = params => {
    setLoading(true)

    RequesterConfigurator.get(requesterConfiguratorMethods.GET_DESIGN, params, redirectMessage)
      .then(datas => {
        const { leathers, fabrics, colors, paints } = datas

        const extenalColors = colors.filter(item => item.external === true)

        const color = extenalColors.map(item => ({
          label: item.wording,
          value: item.reference
        }))

        const type = paints.map(paint => ({
          id: paint.id,
          label: paint.equipment,
          price: paint.inclVatPrice,
          serial: paint.serial
        }))

        const interior = {
          leathers: leathers.map(item => ({
            id: item.id,
            label: item.equipment,
            price: item.inclVatPrice,
            serial: item.serial
          })),
          fabrics: fabrics.map(item => ({
            id: item.id,
            label: item.equipment,
            price: item.inclVatPrice,
            serial: item.serial
          }))
        }

        const list = {
          exterior: {
            type,
            color
          },
          interior
        }
        setDesigns(list)
      })
      .catch(e => {
        message.error(e)
      })
      .finally(setLoading(false))
  }

  const getContracts = params => {
    setLoading(true)
    RequesterConfigurator.get(
      requesterConfiguratorMethods.GET_SERVICE_AGREEMENTS,
      params,
      redirectMessage
    )
      .then(datas => {
        const { serviceAgreements } = datas

        const list = serviceAgreements.map(item => ({
          label: item.equipment,
          price: item.inclVatPrice
        }))
        setContracts(list)
      })
      .catch(e => message.error(e))
      .finally(setLoading(false))
  }

  return {
    loading,
    getMakes,
    makes,
    getGroupsModel,
    groupsModel,
    getModels,
    models,
    getTrims,
    trims,
    getOptions,
    carOptions,
    getVersions,
    versions,
    getDesign,
    designs,
    contracts,
    getContracts
  }
}

export default useGetConfigurator
